import { render } from "./ButtonWithIcon.vue?vue&type=template&id=cb22bd26"
import script from "./ButtonWithIcon.vue?vue&type=script&lang=js"
export * from "./ButtonWithIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__